export enum ActionConstants {
	OPEN_GET_QUOTE = "OPEN_GET_QUOTE_SHARED",
	CLOSE_GET_QUOTE = "CLODE_GET_QUOTE_SHARED",
	CLEAR = "CLEAR_SHARED"
}
